import React, {ReactElement, ReactNode} from 'react'

import 'swiper/swiper-bundle.css'
import {Autoplay, Navigation, Pagination, Scrollbar} from 'swiper'
import {Swiper, SwiperProps, SwiperSlide} from 'swiper/react'

import {Container} from './styles'

export type SlidesProps = SwiperProps & {
  className?: string
  slides: ReactNode[]
}

export function Slides(props: SlidesProps): ReactElement {
  const {className, slides, ...rest} = props

  return (
    <Container className={className}>
      <Swiper {...rest} modules={[Navigation, Pagination, Autoplay, Scrollbar]}>
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>{slide}</SwiperSlide>
        ))}
      </Swiper>
    </Container>
  )
}
